var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u2705-Feather-(Neutral)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cockpit",
    transform: "translate(-251.000000, -874.000000)",
    stroke: "white",
    strokeWidth: 2,
    className: "toggle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(112.000000, 871.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    transform: "translate(140.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4 L10,4",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "7 0 11 4 7 8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.31c48f74608c821bcf3f9260da25f4a0.svg";
export { ForwardRef as ReactComponent };